export const UserActionTypes = {
    USER_LOGIN: 'USER_LOGIN',
    USER_LOGIN_KEY: 'USER_LOGIN_KEY',
    USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    USER_LOGIN_ERROR: 'USER_LOGIN_ERROR',
    USER_LOGOUT: 'USER_LOGOUT',
    USER_SET_CUSTOMER_INFO: 'USER_SET_CUSTOMER_INFO',
    USER_RESET_PASSWORD_REQUEST: 'USER_RESET_PASSWORD_REQUEST',
    USER_RESET_PASSWORD: 'USER_RESET_PASSWORD',
    USER_RESET_PASSWORD_SUCCESS: 'USER_RESET_PASSWORD_SUCCESS',
    USER_RESET_PASSWORD_ERROR: 'USER_RESET_PASSWORD_ERROR',
    USER_EXPIRED: 'USER_EXPIRED'
};

export const SurveyActionTypes = {
    SURVEY_TEAM_LIST: 'SURVEY_TEAM_LIST',
    SURVEY_ORGANIZATION_LIST: 'SURVEY_ORGANIZATION_LIST',
    SURVEY_TEAM_LIST_SUCCESS: 'SURVEY_TEAM_LIST_SUCCESS',
    SURVEY_ORGANIZATION_LIST_SUCCESS: 'SURVEY_ORGANIZATION_LIST_SUCCESS',
    SURVEY_TEAM_LIST_ERROR: 'SURVEY_TEAM_LIST_ERROR',
    SURVEY_ORGANIZATION_LIST_ERROR: 'SURVEY_ORGANIZATION_LIST_ERROR',
    SURVEY_SAVE: 'SURVEY_SAVE',
    SURVEY_SAVE_SUCCESS: 'SURVEY_SAVE_SUCCESS',
    SURVEY_SAVE_ERROR: 'SURVEY_SAVE_ERROR',
    SURVEY_CLEAR: 'SURVEY_CLEAR',
    SURVEY_LOAD_ANSWER: 'SURVEY_LOAD_ANSWER',
    SURVEY_LOAD_ANSWER_SUCCESS: 'SURVEY_LOAD_ANSWER_SUCCESS',
    SURVEY_LOAD_ANSWER_ERROR: 'SURVEY_LOAD_ANSWER_ERROR',
    SURVEY_LOAD_DEMOGRAPHIC_ANSWER: 'SURVEY_LOAD_DEMOGRAPHIC_ANSWER',
    SURVEY_LOAD_DEMOGRAPHIC_ANSWER_SUCCESS: 'SURVEY_LOAD_ANSWER_DEMOGRAPHIC_SUCCESS',
    SURVEY_LOAD_DEMOGRAPHIC_ANSWER_ERROR: 'SURVEY_LOAD_ANSWER_EDEMOGRAPHIC_ERROR',
    SURVEY_SAVE_ANSWER: 'SURVEY_SAVE_ANSWER',
    SURVEY_SAVE_ANSWER_SUCCESS: 'SURVEY_SAVE_ANSWER_SUCCESS',
    SURVEY_SAVE_ANSWER_ERROR: 'SURVEY_SAVE_ANSWER_ERROR',
    SURVEY_SAVE_DEMOGRAPHIC_ANSWER: 'SURVEY_SAVE_DEMOGRAPHIC_ANSWER',
    SURVEY_SAVE_DEMOGRAPHIC_ANSWER_SUCCESS: 'SURVEY_SAVE_DEMOGRAPHIC_ANSWER_SUCCESS',
    SURVEY_SAVE_DEMOGRAPHIC_ANSWER_ERROR: 'SURVEY_SAVE_DEMOGRAPHIC_ANSWER_ERROR',
    SURVEY_CLEAR_ERRORS: 'SURVEY_CLEAR_ERRORS'
};

export const TrainingActionTypes = {
    TRAINING_LIST: 'TRAINING_LIST',
    TRAINING_LIST_ERROR: 'TRAINING_LIST_ERROR',
    TRAINING_LIST_SUCCESS: 'TRAINING_LIST_SUCCESS',
    TRAINING_LIST_CLIENT: 'TRAINING_LIST_CLIENT',
    TRAINING_LIST_CLIENT_ERROR: 'TRAINING_LIST_CLIENT_ERROR',
    TRAINING_LIST_CLIENT_SUCCESS: 'TRAINING_LIST_CLIENT_SUCCESS',
    TRAINING_LIST_APPLIED: 'TRAINING_LIST_APPLIED',
    TRAINING_LIST_APPLIED_ERROR: 'TRAINING_LIST_APPLIED_ERROR',
    TRAINING_LIST_APPLIED_SUCCESS: 'TRAINING_LIST_APPLIED_SUCCESS',
    TRAINING_CLEAR: 'TRAINING_CLEAR',
    LOAD_CONTENT: 'LOAD_CONTENT',
    LOAD_CONTENT_SUCCESS: 'LOAD_CONTENT_SUCCESS',
    LOAD_CONTENT_ERROR: 'LOAD_CONTENT_ERROR',
    LOAD_QUIZ: 'LOAD_QUIZ',
    LOAD_QUIZ_SUCCESS: 'LOAD_QUIZ_SUCCESS',
    LOAD_QUIZ_ERROR: 'LOAD_QUIZ_ERROR',
    SAVE_QUIZ: 'SAVE_QUIZ',
    SAVE_QUIZ_SUCCESS: 'SAVE_QUIZ_SUCCESS',
    SAVE_QUIZ_ERROR: 'SAVE_QUIZ_ERROR',
    SAVE_PROGRESS: 'SAVE_PROGRESS',
    SAVE_PROGRESS_SUCCESS: 'SAVE_PROGRESS_SUCCESS',
    SAVE_PROGRESS_ERROR: 'SAVE_PROGRESS_ERROR',
    GET_PROGRESS: 'GET_PROGRESS',
    GET_PROGRESS_SUCCESS: 'GET_PROGRESS_SUCCESS',
    GET_PROGRESS_ERROR: 'GET_PROGRESS_ERROR',
    SAVE_STATUS: 'SAVE_STATUS',
    SAVE_STATUS_SUCCESS: 'SAVE_STATUS_SUCCESS',
    SAVE_STATUS_ERROR: 'SAVE_STATUS_ERROR',
    TRAINING_CLEAR_ERRORS: 'TRAINING_CLEAR_ERRORS'
};

export const BrainstormActionTypes = {
    CLEAR: 'CLEAR',
    LIST_BRANCHES: 'LIST_BRANCHES',
    LIST_BRANCHES_SUCCESS: 'LIST_BRANCHES_SUCCESS',
    LIST_BRANCHES_ERROR: 'LIST_BRANCHES_ERROR',
    LIST_DEPARTMENTS: 'LIST_DEPARTMENTS',
    LIST_DEPARTMENTS_SUCCESS: 'LIST_DEPARTMENTS_SUCCESS',
    LIST_DEPARTMENTS_ERROR: 'LIST_DEPARTMENTS_ERROR',
    LIST_COLLABORATORS: 'LIST_COLLABORATORS',
    LIST_COLLABORATORS_SUCCESS: 'LIST_COLLABORATORS_SUCCESS',
    LIST_COLLABORATORS_ERROR: 'LIST_COLLABORATORS_ERROR',
    GET_COLLABORATOR: 'GET_COLLABORATOR',
    GET_COLLABORATOR_SUCCESS: 'GET_COLLABORATOR_SUCCESS',
    GET_COLLABORATOR_ERROR: 'GET_COLLABORATOR_ERROR',
    LIST_IDEAS_IMPLEMENTER: 'LIST_IDEAS_IMPLEMENTER',
    LIST_IDEAS_IMPLEMENTER_SUCCESS: 'LIST_IDEAS_IMPLEMENTER_SUCCESS',
    LIST_IDEAS_IMPLEMENTER_ERROR: 'LIST_IDEAS_IMPLEMENTER_ERROR',
    LIST_IDEAS_COLLABORATOR: 'LIST_IDEAS_COLLABORATOR',
    LIST_IDEAS_COLLABORATOR_SUCCESS: 'LIST_IDEAS_COLLABORATOR_SUCCESS',
    LIST_IDEAS_COLLABORATOR_ERROR: 'LIST_IDEAS_COLLABORATOR_ERROR',
    GET_IDEA: 'GET_IDEA',
    GET_IDEA_SUCCESS: 'GET_IDEA_SUCCESS',
    GET_IDEA_ERROR: 'GET_IDEA_ERROR',
    SAVE_IDEA: 'SAVE_IDEA',
    SAVE_IDEA_SUCCESS: 'SAVE_IDEA_SUCCESS',
    SAVE_IDEA_ERROR: 'SAVE_IDEA_ERROR',
    CLEAR_ERRORS: 'CLEAR_ERRORS'
};

export const NotificationActionTypes = {
    CLEAR: 'CLEAR',
    CLEAR_ERRORS: 'CLEAR_ERRORS',
    LIST: 'LIST',
    LIST_SUCCESS: 'LIST_SUCCESS',
    LIST_ERROR: 'LIST_ERROR',
    GET: 'GET',
    GET_SUCCESS: 'GET_SUCCESS',
    GET_ERROR: 'GET_ERROR',
    RENEW: 'RENEW',
    RENEW_SUCCESS: 'RENEW_SUCCESS',
    RENEW_ERROR: 'RENEW_ERROR',
    DISPATCH: 'DISPATCH'
}

export const CronosActionTypes = {
    CLEAR_ERRORS: 'CLEAR_ERRORS',
    LIST_TEAMS: 'LIST_TEAMS',
    LIST_TEAMS_SUCCESS: 'LIST_TEAMS_SUCCESS',
    LIST_TEAMS_ERROR: 'LIST_TEAMS_ERROR',
    LIST_PROJECTS: 'LIST_PROJECTS',
    LIST_PROJECTS_SUCCESS: 'LIST_PROJECTS_SUCCESS',
    LIST_PROJECTS_ERROR: 'LIST_PROJECTS_ERROR',
    REORDER: 'REORDER',
    REORDER_SUCCESS: 'REORDER_SUCCESS',
    REORDER_ERROR: 'REORDER_ERROR',
    SAVE_TASK: 'SAVE_TASK',
    SAVE_TASK_SUCCESS: 'SAVE_TASK_SUCCESS',
    SAVE_TASK_ERROR: 'SAVE_TASK_ERROR',
    REMOVE_TASK: 'REMOVE_TASK',
    REMOVE_TASK_SUCCESS: 'REMOVE_TASK_SUCCESS',
    REMOVE_TASK_ERROR: 'REMOVE_TASK_ERROR',
    SAVE_COMMENT: 'SAVE_COMMENT',
    SAVE_COMMENT_SUCCESS: 'SAVE_COMMENT_SUCCESS',
    SAVE_COMMENT_ERROR: 'SAVE_COMMENT_ERROR',
    SAVE_FILE: 'SAVE_FILE',
    SAVE_FILE_SUCCESS: 'SAVE_FILE_SUCCESS',
    SAVE_FILE_ERROR: 'SAVE_FILE_ERROR',
    SAVE_PROJECT: 'SAVE_PROJECT',
    SAVE_PROJECT_SUCCESS: 'SAVE_PROJECT_SUCCESS',
    SAVE_PROJECT_ERROR: 'SAVE_PROJECT_ERROR'
}


// WEBPACK FOOTER //
// ./src/store/action/index.ts